import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types'
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { cloneDeep, find, findIndex } from "lodash";
import CloseOutline from "../icons/Close_Outline";

const TextInput = ({ fieldName, handleChange }) =>
{
  const { t } = useTranslation();
  const { form } = useSelector((state) => state.form);
  const [inputField, setInputField] = useState(find(form, { field: fieldName }))
  const [open, setOpen] = useState(false)

  /**
   * useEffect hook for updating the input field whenever the form state is updated
   */
  useEffect(() =>
  {
    let formData = cloneDeep(form)
    let fieldIndex = findIndex(formData, { field: fieldName })
    setInputField(formData[fieldIndex])
  }, [form, fieldName])

  useEffect(() =>
  {
    if (inputField?.error)
    {
      setOpen(true)
    }
    else
    {
      setOpen(false)
    }
  }, [inputField?.error, inputField?.errorMessage])

  if (!inputField)
  {
    return null
  }

  const handleInputChange = (val) =>
  {
    handleChange(fieldName, val)
  }

  return (
    <div className="col-md-24 form-group">
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div>
          <Tooltip
            placement="right"
            PopperProps={{
              disablePortal: true,
            }}
            onClose={() => setOpen(false)}
            open={open && inputField.error}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            title={
              <div className="password-req-tooltip">
                {Array.isArray(inputField.errorMessage) ? (
                  inputField.errorMessage.map((message, index) => (
                    <p key={index}>
                      <CloseOutline stroke="#e81123" />&nbsp;{message}
                    </p>
                  ))
                ) : (
                  <p><CloseOutline stroke="#e81123" />&nbsp;{inputField.errorMessage}</p>
                )}
              </div>
            }
          >
            <div className={`placeholderContainer border-bottom ${inputField.error ? "has-error" : ""}`}>
              <label htmlFor={fieldName} className="form-label">{t(`widget.${fieldName}`)}</label>
              <input
                id={fieldName}
                type="text"
                autoComplete="off"
                className="form-control text-box"
                value={inputField.value || ""}
                maxLength={65}
                onChange={(e) => handleInputChange(e.target.value)}
                onClick={() =>
                {
                  if (inputField.error)
                  {
                    setOpen(true)
                  }
                }}
              />
            </div>
          </Tooltip>
        </div>
      </ClickAwayListener>
    </div>
  );
};

TextInput.propTypes = {
  fieldName: PropTypes.string,
  handleChange: PropTypes.func
};

export default TextInput;